<div class="container px3">
    @if (viewConfig.loading) {
      <app-spinner-fullscreen></app-spinner-fullscreen>
      } @else if (viewConfig.error) {
      <ngb-alert (closed)="viewConfig.setDefault()" type="danger">{{ viewConfig.error }}</ngb-alert>
      }
    <div class="ind-page-title pb-0">
      <div class="row align-items-center pb-3">
        <div class="col-6 p-0  m-0 breadcrumb">
          <div
            role="navigation"
            class="d-flex"
            aria-label="Admin list breadcrumb navigation"
          >
            <p >Admin</p> <p class="breadcrumb-divider"  >></p> <p class="" >Admin List</p>
          </div>
          <div class="d-flex align-items-center" role="banner">
            <img [addAaTags]="'Admin list logo'" src="/icons/bold/admin-list.svg" />
            <p class="heading ps-2" role="heading" aria-level="1">Admin List</p>
          </div>
        </div>
        <div class="col-6 text-right p-0">
          <app-button class="add ind-button-md" type="secondary" label="+ Create New User" (click)="openCreateUser()" (keydown.enter)="openCreateUser()" (keydown.space)="openCreateUser()"></app-button>
        </div>
      </div>
    </div>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li
        class="nav-link nav-item"
        role="tab"
        [ngClass]="isUserPage ? 'active' : ''"
        id="users-tab"
        addAaTags="User Management"
        [attr.aria-selected]="isUserPage ? 'true' : 'false'"
        [routerLink]="['/admin/users']"
      >
        User Management
      </li>
      <li
        class="nav-item nav-link"
        role="tab"
        [ngClass]="isUserPage ? '' : 'active'"
        id="chatbot-tab"
        addAaTags="Chatbot Management"
        [attr.aria-selected]="isUserPage ? 'false' : 'true'"
        [routerLink]="['/admin/chatbot-management']"
      >
        Chatbot Management
      </li>
    </ul>
    <div class="container">
        <router-outlet></router-outlet>
    </div>
</div>